import { 
    Button,
    Modal, ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure }
from "@chakra-ui/react";

export default function CreditsModal(){
        const { isOpen, onOpen, onClose } = useDisclosure()
        return (
          <>
            <Button onClick={onOpen} variant='ghost'>
                <Text fontSize={"4xl"} fontStyle={"italic"}fontFamily={"Magneto"}>?    ?</Text>
            </Button>
      
            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader textAlign="center">🌈QCJam 2023🌈</ModalHeader>
                <ModalCloseButton />
                <ModalBody textAlign="center" p="20px">
                  by missymae#2783<br/>
                  <br/>
                  Built with JavaScript, React, <a href="https://chakra-ui.com/getting-started">Chakra UI</a>, <a href="https://www.beepbox.co/"> BeepBox.com</a>, Howler.js
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        )
      }
